interface IProps {
  method: 'card' | 'deposit';
  price: number;
  cardFee: number;
}

export const calculatePriceWithFee = ({ cardFee, method, price }: IProps) => {
  return method === 'card' ? parseFloat((price + parseFloat((price * (cardFee/100)).toString())).toFixed(2)) : price;
}